const DEFAULT_CONFIG = {
    root: location.href.substr(0, location.href.lastIndexOf('/') + 1),
};

const config = Object.assign({}, DEFAULT_CONFIG, window.app_config || {});

export default {
    get: function get(path) {
        return path.split('.').reduce((acc, cur) => {
            if (acc) return acc[cur];
        }, config);
    },

    set: function set(key, value) {
        config[key] = value;

        return value;
    },
};
